export default "__VITE_ASSET__OqMO8jCg__"